var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.hasRole(['manager', 'admin']))?_c('div',[_c('datatable',{ref:"datatable",attrs:{"isAuth":_vm.isAuth,"user":_vm.user},on:{"destroy":_vm.destroy}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e4d6ca8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/users/views/html/Index.html
// module id = null
// module chunks = 